import {
  IinitialStateServerEsg,
  Iprojects,
} from "../pages/Esg/EsgDashboard.type";
// import DataJson from "../data/Stemp.json";
// import DataJsonFintech from "../data/DataFintech.json";
import DataJsonFintechWeakSignals from "../data/weak_signals.json";
import DataJsonStateInitiative from "../data/StateInitiative.json";
import {
  // Idirections,
  // IFintechTrend,
  // IinitialStateServerFintech,
  IParseWeakSignals,
} from "../pages/Fintech/FintechDashboard.type";
import {Iinitiatives} from "../pages/StateInitiative/StateInitiative.type";
import {initialStateFilters} from "../pages/Dashboard/Dashboard.const";

export const filteringClusters = (filters: any, radarData: any) => {
  const isActiveFilter = checkFilters(filters);
  let filteredClusters: any[] = [];

  if (filters && typeof radarData != "undefined" && isActiveFilter.length > 0) {
    for (let i = 0; i < isActiveFilter.length; i++) {
      //@ts-ignore
      radarData.clusters.forEach((cluster) => {
        Object.keys(cluster).forEach((key) => {
          isActiveFilter.forEach((filterArray) => {
            Object.keys(filterArray).forEach((keyFilter) => {
              if (
                keyFilter === key &&
                filterArray[key] === cluster[key] &&
                checkCluster(filteredClusters, cluster)
              )
                filteredClusters.push(cluster);
            });
          });
        });
      });
    }

    return {...radarData, clusters: filteredClusters};
  } else return radarData;
};

export const checkFilters = (filters: any) => {
  const list: any[] = [];

  Object.keys(filters).forEach((key, index) => {
    if (typeof filters[key] == "boolean" && filters[key])
      list.push({[key]: filters[key]});
    if (typeof filters[key] == "number" && filters[key] !== 0)
      list.push({[key]: filters[key]});
  });

  return list;
};

const checkCluster = (list: any[], item: any) => {
  let answer = list.find((cluster) => cluster.name === item.name);

  return typeof answer == "undefined" ? true : false;
};

// export const getEsgProjectData = (projectId: number) => {
//   const dataFromJson: IinitialStateServerEsg = JSON.parse(
//     JSON.stringify(DataJson)
//   );
//   const project: Iprojects | undefined = dataFromJson.projects.find(
//     (project) => {
//       return project.id === projectId;
//     }
//   );

//   return project;
// };

// export const getFintechData = async (trendId: number) => {
//   const fileNumber = trendId;
//   if (!fileNumber) return undefined;

//   const dataJsonFintechTrends = await import(
//     `../data/trends/${fileNumber}.json`
//   );
//   const dataFromJson: IFintechTrend = JSON.parse(
//     JSON.stringify(dataJsonFintechTrends)
//   );

//   return dataFromJson;
// };

export const getFintechWeakSignals = async (trendId: number) => {
  const dataFromJson: IParseWeakSignals = JSON.parse(
    JSON.stringify(DataJsonFintechWeakSignals)
  );
  const result = dataFromJson.weak_signals.find((trend) => {
    return trend.id === trendId;
  });

  return result;
};

// export const getNameDirectionFintech = (directionId: number) => {
//   const dataFromJson: IinitialStateServerFintech = JSON.parse(
//     JSON.stringify(DataJsonFintech)
//   );

//   const project: Idirections | undefined = dataFromJson.directions.find(
//     (trend) => {
//       return trend.id === directionId;
//     }
//   );

//   return project?.name;
// };

export const getStateInitiativeData = async (dotId: number) => {
  const dataFromJson: Iinitiatives = JSON.parse(
    JSON.stringify(DataJsonStateInitiative)
  );
  const result = dataFromJson.initiatives.find((item) => {
    return item.id === dotId;
  });

  return result;
};

export const getStateInitiativeDataNew = async (dotId: number) => {
  const dataFromJson: Iinitiatives = JSON.parse(
    JSON.stringify(DataJsonStateInitiative)
  );
  const result = dataFromJson.initiatives.find((item) => {
    return item.id === dotId;
  });

  return result;
};

export const arrayFromNumber = (clusters: number) =>
  Array.from({length: clusters}, (_, index) => index);

export const getDomainFromUrl = (url: string): string => {
  try {
    const {hostname} = new URL(url);
    return hostname.replace("www.", "");
  } catch (error) {
    console.error("Invalid URL:", url);
    return url;
  }
};

export const deepEqual = (obj1: any, obj2: any): boolean => {
  if (obj1 === obj2) return true;

  if (
    typeof obj1 !== "object" ||
    obj1 === null ||
    typeof obj2 !== "object" ||
    obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
};
